const HEIC_MIME_TYPES = ['image/heic', 'image/heif'];

const isHeicFileCandidate = (file: File) =>
  HEIC_MIME_TYPES.includes(file.type.toLowerCase()) ||
  /\.hei[cf]$/i.test(file.name);

export const normalizePhotoFile = async (file: File) => {
  if (!isHeicFileCandidate(file)) return file;

  const { heicTo, isHeic } = await import('heic-to');

  if (!(await isHeic(file))) return file;

  const jpegBlob = await heicTo({
    blob: file,
    type: 'image/jpeg',
    quality: 0.9,
  });
  const jpegFileName = file.name.replace(/\.hei[cf]$/i, '.jpg');

  return new File([jpegBlob], jpegFileName, {
    type: 'image/jpeg',
    lastModified: file.lastModified,
  });
};
